import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { NgxSpinnerService } from 'ngx-spinner';
import { switchMap, tap } from 'rxjs';
import { resetPasswordApi } from 'src/app/shared/constants/api.constants';
import { Toast } from 'src/app/shared/enums/toast';
import { ToastService, AuthService, HttpBaseService } from '@evento-ng/libs';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: UntypedFormGroup;
  constructor(
    private spinner: NgxSpinnerService,
    private toast: ToastService,
    private dataService: HttpBaseService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private fb: UntypedFormBuilder,
    private recaptchaV3Service: ReCaptchaV3Service,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.changePasswordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: [this.MustMatch('password', 'confirmPassword')],
      }
    );
  }

  MustMatch(controlName: string, matchingControlName: string): any {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  changePassword(): void {
    this.spinner.show();
    const id = this.route.snapshot.paramMap.get('id');
    this.recaptchaV3Service
      .execute('changePasswordApi')
      .pipe(
        switchMap((token) => {
          return this.dataService.put(
            `${resetPasswordApi}/change-password/${id}`,
            {
              ...this.changePasswordForm.value,
              recaptcha: token,
            }
          );
        }),
        tap((_) => {
          this.spinner.hide();
          this.router.navigateByUrl('/auth/login');
          this.authService.logout().subscribe({
            next: () => {
              console.log('Logout successful');
              // Navigation is already handled in clearLocalStorage()
            },
            error: (err) => {
              console.error('Logout error:', err);
              // Error is already handled in the service
            },
          });

          this.toast.show(
            'Success',
            this.translate.instant('Password has been changed'),
            {
              classname: Toast.success,
            }
          );
        })
      )
      .subscribe();
  }
}
